import { Component } from '@ecs/Component';

export class CameraShake implements Component {
  readonly type = 'CameraShake';

  constructor(
    public trauma: number = 0, // 0..1, shake magnitude is trauma squared
    public decayPerFrame: number = 0.04,
    public maxOffset: number = 10
  ) {}
}
